import defaults from 'lodash/defaults';
import fromPairs from 'lodash/fromPairs';
import keyBy from 'lodash/keyBy';

import { emptyCountrySplit } from '../../quotes/constants';

export function normalizeQuoteLine(quoteLine) {
  return {
    ...quoteLine,
    countrySplit: defaults(
      fromPairs(
        (quoteLine.countrySplit || []).map(ql => [ql.countryCode, ql.share]),
      ),
      emptyCountrySplit,
    ),
  };
}

export default function normalizeQuote(apiQuote) {
  const apiQuoteLines = apiQuote.quoteLines || [];
  const quote = {
    ...apiQuote,
    quoteLines: apiQuoteLines.map(ql => ql.id),
  };
  const quoteLinesById = keyBy(apiQuoteLines.map(normalizeQuoteLine), 'id');
  return {
    quote,
    quoteLinesById,
  };
}
